import { signal } from 'services/SignalsService'

const name = 'STICKY'
async function execute() {
  const stickyPosition = game.models.FreespinModel.get().stickyPosition

  if(!stickyPosition.length){
    return Promise.resolve()
  }
  while (stickyPosition.length) {
    const item = stickyPosition.shift()
    signal.dispatch('STICKY-SYMBOL', item)
  }

  return signal.promise('STICKY-SYMBOL:DONE')
}

export function getStickyAction() {
  return {
    name,
    execute,
  }
}
